var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDriversCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conductores_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 50,
    height: 50,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27",
    "data-name": "Rect\\xE1ngulo 27",
    width: 36.135,
    height: 37.805,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_19",
    "data-name": "Enmascarar grupo 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(6.933 6.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M0,33.893c.095-.716.164-1.437.289-2.147a17.987,17.987,0,0,1,13.3-14.255c.083-.021.163-.053.278-.091A9.146,9.146,0,0,1,8.9,9.374a8.806,8.806,0,0,1,2.778-6.76A9.2,9.2,0,1,1,22.355,17.378c.771.256,1.563.463,2.31.776a17.711,17.711,0,0,1,11.29,14.077A10.292,10.292,0,0,1,36.1,34.87a3.247,3.247,0,0,1-2.716,2.869.933.933,0,0,0-.164.066H27.391c-.079-.026-.156-.058-.236-.078a3.313,3.313,0,0,1-2.561-2.519c-.024-.09-.044-.182-.077-.317l-1.621.941c.241,1.2.151,1.452-.673,1.972h-.591a1.465,1.465,0,0,1-.859-1.214,2.721,2.721,0,0,0-5.363-.014,1.424,1.424,0,0,1-.939,1.227H14.1c-.436-.152-.848-.376-.894-.874a9.035,9.035,0,0,1,.077-1.377l-1.6-.926c-.016.122-.024.205-.037.288A3.275,3.275,0,0,1,9.1,37.7c-.178.04-.358.071-.538.106H2.879c-.079-.026-.156-.058-.237-.077a3.173,3.173,0,0,1-2.2-1.639A8.836,8.836,0,0,1,0,34.852v-.96m30.509,1.675c.081.009.117.016.153.016.664,0,1.329,0,1.993,0A1.168,1.168,0,0,0,33.937,34.2a23.436,23.436,0,0,0-.519-3.307A15.846,15.846,0,0,0,16.511,19.229a15.425,15.425,0,0,0-9.942,4.878A15.426,15.426,0,0,0,2.227,34.33a1.114,1.114,0,0,0,1.211,1.254c.627,0,1.255,0,1.882,0,.117,0,.234-.011.342-.017V33.372c-.2,0-.368.005-.538,0A1.124,1.124,0,0,1,3.991,32.25a1.11,1.11,0,0,1,1.155-1.091c.529-.006,1.059-.022,1.587.006a.632.632,0,0,0,.645-.349,12.7,12.7,0,0,1,12.968-5.654,12.569,12.569,0,0,1,8.517,5.749.478.478,0,0,0,.474.251c.578-.014,1.156-.012,1.734,0a1.1,1.1,0,0,1,1.115,1.092,1.118,1.118,0,0,1-1.059,1.115c-.2.014-.409,0-.619,0ZM15.325,2.829a6.961,6.961,0,0,0,4.593,13.108,6.845,6.845,0,0,0,5.1-7.117,7.288,7.288,0,0,1-9.691-5.991M26.378,31.256a10.44,10.44,0,0,0-16.413-.188L12.2,32.361l2.255,1.309c.119-.11.217-.2.317-.292a4.951,4.951,0,0,1,6.864.222.385.385,0,0,0,.579.077c1.383-.819,2.779-1.618,4.167-2.421M17.5,2.279a4.966,4.966,0,0,0,2.546,4.069,4.862,4.862,0,0,0,4.485.244A6.853,6.853,0,0,0,17.5,2.279M7.927,33.392v2.155A1.277,1.277,0,0,0,9.265,35.1,1.1,1.1,0,0,0,9.3,33.886c-.306-.534-.819-.554-1.376-.494m20.332.005a1.241,1.241,0,0,0-1.364.5,1.072,1.072,0,0,0,.056,1.239,1.178,1.178,0,0,0,1.308.392Z",
    transform: "translate(0 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriversCard);
export default __webpack_public_path__ + "static/media/icon_drivers_card.f518446fd8a746da16675a0c6b8e3a9e.svg";
export { ForwardRef as ReactComponent };